export function getApiDomain() {
  return process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_API_URI
    : "";
}
